import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';

import './css/style.scss';

import { focusHandling } from 'cruip-js-toolkit';

// Import pages
import DashboardPage from './pages/DashboardPage/DashboardPage';
import ManagementListPage from './pages/ManagementListPage/ManagementListPage';
import AssignmentsPage from './pages/AssignmentsPage/AssignmentsPage';
import ExpedientList from './pages/ExpedientsListPage/ExpedientListPage';
import Login from './pages/login';
import Signup from './pages/signup';
import UsersPage from './pages/UsersPage/UsersPage';
import ExpedientView from './pages/ExpedientView/ExpedientView';
import ProfilePage from './pages/ProfilePage/ProfilePage';
import ImportExpedients from './pages/importExpedients';
import ForgetPassword from './pages/forgetPassword';
import ResetPassword from './pages/resetPassword';
import ChatDebtor from './pages/chatDebtors';
import LandingPaymentPage from './pages/LandingPaymentPage/LandingPaymentPage';
import PreivacyPolicy from './pages/privacyPolicy';
import Task from './pages/tasks';
import RecoveredAmountList from './pages/recoveredAmountsList';
import DebtorList from './pages/DebtorsListPage/DebtorsListPage';
import SettingsPage from './pages/SettingsPage/SettingsPage';
import UnmatchedEmailsPage from './pages/UnmatchedEmailsPage/UnmatchedEmailsPage';
import UnmatchedWhatsappsPage from './pages/UnmatchedWhatsappsPage/UnmatchedWhatsappsPage';
import AIAgentPage from './pages/AIAgentPage/AIAgentPage';
import CallSessionPage from './pages/CallSessionPage/CallSessionPage';
import CallSessionHost from './components/call-session/CallSessionHost';
import PartnersPage from './pages/PartnersPage/PartnersPage';
import PortfolioPerformancePage from './pages/PortfolioPerformancePage/PortfolioPerformancePage';
import PaymentPlansPage from './pages/PaymentPlansPage/PaymentPlansPage';
import CostsPage from './pages/CostsPage/CostsPage';
import ArBillingPage from './pages/ArBillingPage/ArBillingPage';
import ArReviewPage from './pages/ArReviewPage/ArReviewPage';
import TodayPage from './pages/TodayPage/TodayPage';
import SupportChat from './components/SupportChat';
import ArExitRulesPage from './pages/ArExitRulesPage/ArExitRulesPage';
import ArArranquePage from './pages/ArArranquePage/ArArranquePage';
import PlantillasPage from './pages/PlantillasPage/PlantillasPage';
import AuditPage from './pages/AuditPage/AuditPage';
import BulkDocumentsPage from './pages/BulkDocumentsPage/BulkDocumentsPage';
import { Navigate } from 'react-router-dom';
import userStore from './store/userStore';
import { isPartnerPageAllowed, PARTNER_HOME } from './utils/partnerRoutes';

function App() {
  const location = useLocation();
  const user = userStore(state => state.user);

  useEffect(() => {
    document.querySelector('html').style.scrollBehavior = 'auto';
    window.scroll({ top: 0 });
    document.querySelector('html').style.scrollBehavior = '';
    focusHandling('outline');
  }, [location.pathname]); // triggered on route change

  // Un despacho colaborador solo entra en sus tres pantallas; el resto le daría
  // 403 en el backend, así que se le devuelve a Reclamaciones.
  if (!isPartnerPageAllowed(user, location.pathname)) {
    return <Navigate to={PARTNER_HOME} replace />;
  }

  return (
    <>
      {/*
        FUERA del <Routes>, y es el punto entero de este componente: la sesión de
        llamadas del gestor no puede morir al cambiar de pantalla. Aquí viven el
        socket, el latido y el elemento de audio, más la barra flotante que le
        deja tipificar sin volver a /call-session.

        No pinta nada mientras no haya sesión abierta, así que en login y en el
        resto de la aplicación es invisible.
      */}
      <CallSessionHost />
      {/* El chat de ayuda del cliente (Crisp). Solo para el cliente; no pinta nada. */}
      <SupportChat />

      <Routes>
        <Route path='/chat-debtor/:id' element={<ChatDebtor />} />
        <Route path='/dashboard' element={<DashboardPage />} />
        <Route path='/login' element={<Login />} />
        <Route path='/registro' element={<Signup />} />
        <Route path='/users' element={<UsersPage />} />
        <Route path='/view/:id' element={<ExpedientView />} />
        <Route path='/profile/:id' element={<ProfilePage />} />
        <Route path='/expedients' element={<ExpedientList />} />
        <Route path='/management' element={<ManagementListPage />} />
        <Route path='/assignments' element={<AssignmentsPage />} />
        <Route path='/call-session' element={<CallSessionPage />} />
        <Route path='/recovered-amounts' element={<RecoveredAmountList />} />
        <Route path='/import-expedients' element={<ImportExpedients />} />
        <Route path='/forgot-password' element={<ForgetPassword />} />
        <Route path='/reset-password/:id' element={<ResetPassword />} />
        <Route path='/generate-link-stripe-sms/:id' element={<LandingPaymentPage />} />
        <Route path='/generate-link-stripe-email/:id' element={<LandingPaymentPage />} />
        <Route path='/generate-link-stripe-chat/:id' element={<LandingPaymentPage />} />
        <Route path='/privacy-policy' element={<PreivacyPolicy />} />
        <Route path='/tasks' element={<Task />} />
        <Route path='/settings' element={<SettingsPage />} />
        <Route path='/debtors-with-expedients' element={<DebtorList />} />
        <Route path='/unmatched-emails' element={<UnmatchedEmailsPage />} />
        <Route path='/unmatched-whatsapps' element={<UnmatchedWhatsappsPage />} />
        <Route path='/ai-agent' element={<AIAgentPage />} />
        <Route path='/partners' element={<PartnersPage />} />
        <Route path='/portfolio-performance' element={<PortfolioPerformancePage />} />
        <Route path='/payment-plans' element={<PaymentPlansPage />} />
        <Route path='/costs' element={<CostsPage />} />
        <Route path='/ar-billing' element={<ArBillingPage />} />
        <Route path='/ar-review' element={<ArReviewPage />} />
        <Route path='/hoy' element={<TodayPage />} />
        <Route path='/ar-exit-rules' element={<ArExitRulesPage />} />
        <Route path='/ar-arranque' element={<ArArranquePage />} />
        {/* «Plantillas»: WhatsApp, correo y SMS en pestañas. Las dos rutas viejas
            llevan a su pestaña para que no se rompa ningún enlace guardado. */}
        <Route path='/plantillas' element={<PlantillasPage />} />
        <Route path='/ar-templates' element={<Navigate to='/plantillas?canal=whatsapp' replace />} />
        <Route path='/ar-email' element={<Navigate to='/plantillas?canal=correo' replace />} />
        <Route path='/audit' element={<AuditPage />} />
        <Route path='/bulk-documents' element={<BulkDocumentsPage />} />
        <Route path='*' element={<Navigate to='/login' />} />
      </Routes>
    </>
  );
}

export default App;
